const TypePersonInvoiceEnum = {
    FISICA: 'FISICA',
    MORAL: 'MORAL',
    VALIDATE_RFC_PHYSICAL: 13,
    VALIDATE_RFC_MORAL: 12,
};

export default TypePersonInvoiceEnum;